export default {
  reqTitle: '',
  phase: '',
  group: '',
  item: '',
  subItem: 0,
  todoType: 'new',
  workfactor: null,
  planstDate: '',
  targetDate: '',
  plnProc: { plnStatus: 'planned'   , plnDate: '', plnBy: '', plnProg: 100,},
  hldProc: { hldStatus: 'hold'      , hldDate: '', hldBy: '', hldProg: 0,},
  reqProc: { reqStatus: 'requested' , reqDate: '', reqBy: '', reqProg: 0,},
  issProc: { issStatus: 'issued'    , issDate: '', issBy: '', issProg: 0,},
  verProc: { verStatus: 'verified'  , verDate: '', verBy: '', verProg: 0,},
  proProc: { proStatus: 'progress'  , proDate: '', proBy: '', proProg: 0,},
  comProc: { comStatus: 'completed' , comDate: '', comBy: '', comProg: 0,},
  lunProc: { lunStatus: 'launched'  , lunDate: '', lunBy: '', lunProg: 0,},
  requirement: '',
  jobLog: '',
  files: [],
}